import { PRIVACY_VERSION, TERMS_VERSION } from "@/lib/legalDocuments";

export function getLegalAcceptanceStatus(profile = {}) {
  const hasCurrentTerms = profile?.termsVersion === TERMS_VERSION && Boolean(profile?.termsAcceptedAt);
  const hasCurrentPrivacy =
    profile?.privacyVersion === PRIVACY_VERSION && Boolean(profile?.privacyAcknowledgedAt);

  return {
    hasCurrentTerms,
    hasCurrentPrivacy,
    needsAcceptance: !hasCurrentTerms || !hasCurrentPrivacy,
    requiredTermsVersion: TERMS_VERSION,
    requiredPrivacyVersion: PRIVACY_VERSION,
  };
}
